import { translate } from '@repo/phrase';

export const getAssetDetailsTitle = (type: string, alias?: string) => {
    if (alias) {
        return alias;
    }

    switch (type) {
        case 'ISOM':
        case 'SALESORDER': {
            return translate('order_status_header_order_id');
        }
        case 'DRAFT': {
            return translate('order_status_header_draft_id');
        }
        case 'SALJAPRO_QUOTATION': {
            return translate('order_status_header_quotation_id');
        }
        default: {
            return type;
        }
    }
};
